const FacetReducerInitialState = {
  category_1: [''],
  category_3: ['']
};

export default FacetReducerInitialState;
